const CARAT_UPGRADE_MAP = {
  "1.00": 45986438578316,
  "1.50": 45986438611084,
  "2.00": 45986438643852,
  "3.00": 45986438676620,
  "4.00": 45986438709388,
  "5.00": 45986438742156
};

document.addEventListener('minimog:product-form:loaded', (event) => {
  const formInstance = event.detail.productForm;
  const formEl = event.detail.element;

  // Save original buildCartData method
  const originalBuildCartData = formInstance.buildCartData.bind(formInstance);

  formInstance.buildCartData = function () {
    const data = originalBuildCartData();

    // Get selected carat
    const carat = formEl.querySelector(
      'input[name="properties[Carat Weight]"]:checked'
    )?.value;

    if (carat) {
      const cleanCarat = carat.replace('ct', '').trim();
      const upgradeVariantId = CARAT_UPGRADE_MAP[cleanCarat];

      if (upgradeVariantId) {
        if (!data.items) {
          data.items = [{
            id: data.id,
            quantity: data.quantity,
            properties: data.properties || {}
          }];
        }

        data.items.push({
          id: upgradeVariantId,
          quantity: 1,
          properties: {
            "Linked Product": "Ring",
            "Carat Weight": carat
          }
        });

        delete data.id; // Remove original single id
      }
    }

    return data;
  };
});
